export default {
	primary: '#ff3300'
}


// WEBPACK FOOTER //
// ./src/themes/pureredTheme.js